import type { AppRouteRecordRaw } from '@/router/types'
import { Layout } from '@/utils/routerHelper'

/**
 * iot 物联网模块路由配置
 */
const iotRoutes: AppRouteRecordRaw[] = [
  {
    // 新窗口模式下 iot 路由位于 /ai-business-center/iot 前缀下，根路由必须带前缀，
    // 否则 children 的相对路径（如 product/product/detail/:id）无法命中 /ai-business-center/iot/... 形式的 URL
    path: '/ai-business-center/iot',
    component: Layout,
    name: 'IOT',
    meta: { hidden: true },
    // 新窗口默认落地页：模块 config 的 standalonePath/entryPath 是 /ai-business-center/iot（目录级，无组件），
    // 不加 redirect 会渲染空白内容区；与 ERP 静态壳一致，统一重定向到 IoT 首页
    redirect: '/ai-business-center/iot/home',
    children: [
      {
        path: 'product/product/detail/:id',
        name: 'IoTProductDetail',
        meta: {
          title: '产品详情',
          noCache: true,
          hidden: true,
          activeMenu: '/ai-business-center/iot/device/product'
        },
        component: () => import('@/views/iot/product/product/detail/index.vue')
      },
      {
        path: 'device/detail/:id',
        name: 'IoTDeviceDetail',
        meta: {
          title: '设备详情',
          noCache: true,
          hidden: true,
          activeMenu: '/ai-business-center/iot/device/device'
        },
        component: () => import('@/views/iot/device/device/detail/index.vue')
      },
      {
        path: 'ota/operation/firmware/detail/:id',
        name: 'IoTOtaFirmwareDetail',
        meta: {
          title: '固件详情',
          noCache: true,
          hidden: true,
          activeMenu: '/ai-business-center/iot/operation/ota/firmware'
        },
        component: () => import('@/views/iot/ota/firmware/detail/index.vue')
      }
    ]
  }
]

export default iotRoutes
